import mitt from 'mitt';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var WHITELISTED_METHODS = ['on', 'off', 'emit'];
function prefixMethods(api) {
  if (!api) throw new TypeError("eventbus-js#prefixMethods/error: Cannot prefix API methods");
  var prefixedAPI = WHITELISTED_METHODS.reduce(function (accumulator, methodName) {
    var prefixedMethodName = "$" + methodName;
    if (!(prefixedMethodName in api)) {
      accumulator[prefixedMethodName] = api[methodName];
    }
    return accumulator;
  }, {});
  return prefixedAPI;
}

var mockEventEmit = function mockEventEmit() {
  global.restoreEventEmit();
  window.eventBus = window.eventBus || {};
  window.eventBus.emit = jest.fn();
  return window.eventBus.emit;
};
var restoreEventEmit = function restoreEventEmit() {
  if (window.eventBus && window.eventBus.emit) {
    window.eventBus.emit = undefined;
  }
};
var mockEventOn = function mockEventOn() {
  global.restoreEventOn();
  window.eventBus = window.eventBus || {};
  window.eventBus.on = jest.fn();
  return window.eventBus.on;
};
var restoreEventOn = function restoreEventOn() {
  if (window.eventBus && window.eventBus.on) {
    window.eventBus.on = undefined;
  }
};
var mittInstanceStub = {
  on: function on() {
    return true;
  },
  emit: function emit() {
    return true;
  },
  off: function off() {
    return true;
  }
};
var eventBus = /*#__PURE__*/_extends({}, /*#__PURE__*/prefixMethods(mittInstanceStub), mittInstanceStub);
Object.defineProperty(window, 'eventBus', {
  value: eventBus,
  writable: true
});
var stub = (function () {
  global.mockEventEmit = mockEventEmit;
  global.mockEventOn = mockEventOn;
  global.restoreEventEmit = restoreEventEmit;
  global.restoreEventOn = restoreEventOn;
});

var mittInstance = /*#__PURE__*/mitt();
var eventBus$1 = /*#__PURE__*/_extends({}, /*#__PURE__*/prefixMethods(mittInstance), mittInstance);
function exposeGlobals() {
  window.eventBus = eventBus$1;
}

export default eventBus$1;
export { eventBus$1 as eventBus, exposeGlobals, stub as stubEventBus };
//# sourceMappingURL=eventbus-js.esm.js.map
